import React from 'react'
import { Typography } from 'antd'
import PropTypes from 'prop-types'

import { normalizeConcessionBadge } from '../../utils/concessionGalleryItemDefaults'
import badgeStyles from '../ConcessionGalleryItems/ConcessionBadgeFields.module.css'
import styles from './ConcessionVendorGridEditor.module.css'

const { Text } = Typography

const ConcessionVendorCardPreview = ({ vendor }) => {
  if (!vendor) {
    return (
      <div className={styles.previewCard}>
        <Text className={styles.previewLabel}>Preview</Text>
        <div className={styles.previewEmpty}>
          <Text type="secondary">Add a vendor to see the card preview.</Text>
        </div>
      </div>
    )
  }

  const name = vendor.name?.trim() || 'Vendor name'
  const description = vendor.description?.trim()
  const sectionLabel = vendor.section_label?.trim() || ''
  const imageUrl = vendor.image?.url || vendor.image?.src || ''
  const imageAlt = vendor.image?.alt || name
  const badge = normalizeConcessionBadge(vendor.badge)
  const badgeTitle = badge?.title?.trim().toUpperCase() || ''
  const badgeColor = badge?.color || '#d9d9d9'

  return (
    <div className={styles.previewCard}>
      <Text className={styles.previewLabel}>Preview</Text>
      <div className={styles.previewCardInner}>
        <div className={styles.previewImageWrap}>
          {imageUrl ? (
            <img alt={imageAlt} className={styles.previewImage} src={imageUrl} />
          ) : (
            <div className={styles.previewImagePlaceholder}>No image</div>
          )}
          {badgeTitle && (
            <div className={styles.previewImageBadge}>
              <div
                className={badgeStyles.previewBadge}
                style={{ backgroundColor: badgeColor }}
              >
                <span className={badgeStyles.previewTitle}>{badgeTitle}</span>
              </div>
            </div>
          )}
        </div>
        <div className={styles.previewBody}>
          <div className={styles.previewName}>{name}</div>
          {description && (
            <div className={styles.previewDescription}>{description}</div>
          )}
          {sectionLabel && (
            <div className={styles.previewSectionLabel}>{sectionLabel}</div>
          )}
        </div>
      </div>
    </div>
  )
}

ConcessionVendorCardPreview.propTypes = {
  vendor: PropTypes.object
}

export default ConcessionVendorCardPreview
